module.exports = __webpack_public_path__ + "static/media/apple-podcasts.9b860e06.svg";